import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DownloadRelatorioService {

  constructor( private readonly http : HttpClient) { }

  public downloadTermoUtilizacao ( idEmpresa ){
    return this.http.get(`/apiconnect/report/routings-contract/${idEmpresa}/companies`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });

  }
}
